<template>
  <div class="row">
    <div class="col-12">
      <q-form ref="editForm">
        <c-card title="대상공정 상세" class="cardClassDetailForm">
          <template slot="card-button">
            <q-btn-group outline >
              <c-btn 
                v-if="editable && isSelect" 
                :isSubmit="isSave"
                :url="saveUrl"
                :param="process"
                mappingType="PUT"
                label="저장" 
                icon="save"
                @beforeAction="saveProcess"
                @btnCallback="saveProcessCallback" />
            </q-btn-group>
          </template>
          <template slot="card-detail">
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4">
              <template v-if="checkProcessCd">
                <c-process
                  :editable="editable"
                  :disabled="true"
                  label="단위공정"
                  name="processCd"
                  v-model="process.processCd">
                </c-process>
              </template>
              <template v-else>
                <c-text
                  :editable="editable"
                  :disabled="true"
                  label="공정"
                  name="processName"
                  v-model="process.processName">
                </c-text>
              </template>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4">
              <c-dept
                :editable="editable"
                :disabled="!isSelect"
                :required="true"
                type="edit"
                label="평가부서"
                name="assessDeptCd"
                v-model="process.assessDeptCd">
              </c-dept>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4">
              <c-field 
                :required="true" 
                :editable="editable"
                :disabled="!isSelect" 
                type="user" 
                label="평가담당자" 
                name="assessUserId" 
                v-model="process.assessUserId" />
            </div>
            <!-- <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4">
              <c-text
                :editable="editable"
                :disabled="true"
                :afterIcon="editable && isSelect ? [
                  { name: 'search', click: true, callbackName: 'searchWorkMeasure', color: 'teal' },
                  { name: 'close', click: true, callbackName: 'removeWorkMeasure', color: 'red' }
                ] : null"
                label="작업환경측정"
                name="measPlanContent"
                v-model="process.measPlanContent"
                @searchWorkMeasure="searchWorkMeasure"
                @removeWorkMeasure="removeWorkMeasure">
              </c-text>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4">
              <c-text
                :required="true" 
                :disabled="!isSelect"
                :editable="editable"
                type="number"
                label="사용온도(℃)"
                name="temperature"
                v-model="process.temperature">
              </c-text>
            </div> -->
            <div class="col-12">
              <c-textarea
                :editable="editable"
                :disabled="!isSelect"
                label="공정특징설명"
                name="processExplainFeature"
                v-model="process.processExplainFeature">
              </c-textarea>
            </div>
          </template>
        </c-card>
      </q-form>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'charm-target-process-detail',
  props: {
    process: {
      type: Object,
      default: () => ({
        ramRiskAssessmentPlanId: '',  // 평가 일련번호
        processCd: '',  // 단위공정 코드
        processName: '',  // 단위공정명
        ramProcessAssessStepCd: '',  // 평가진행상태
        processExplainFeature: '',  // 공정 특징 설명
        assessDeptCd: '',  // 평가 부서 코드
        assessUserId: '',  // 평가 담당자
        workCycleCd: null,  // 작업발생주기코드
        workingTime: 0,  // 작업시간(1회)
        temperature: null,
        workMeasurementPlanId: '',
        measPlanContent: '',
        regUserId: '',  // 작성자 ID
        chgUserId: '',  // 수정자 ID
        equipments: [],
        charmResultScenarios: [],
      }),
    },
    plantCd: {
      type: String,
      default: function() {
        return '';
      },
    },
    disabled: {
      type: Boolean,
      default: function() {
        return false;
      },
    },
  },
  data() {
    return {
      editable: true,
      saveUrl: '',
      isSave: false,
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '90%',
        top: '10px',
        param: {},
        closeCallback: null,
      },
    };
  },
  computed: {
    isSelect() {
      return this.process 
        && this.process.processCd 
        && !this.disabled 
        && this.process.ramProcessAssessStepCd !== 'RPA0000005' ? true : false
    },
    checkProcessCd() {
      return this.process.processCd.indexOf('WTE') === -1
    }
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.saveUrl = transactionConfig.ram.assessProcess.update.url
      // code setting
      // list setting
    },
    // searchWorkMeasure() {
    //   this.popupOptions.title = '작업환경측정 검색'; // 작업환경측정 검색
    //   this.popupOptions.param = {
    //     type: 'single',
    //     plantCd: this.plantCd,
    //     processCd: this.process.processCd,
    //   };
    //   this.popupOptions.target = () => import(`${'@/pages/sai/wmr/workMeasureResultPop.vue'}`);
    //   this.popupOptions.width = '70%';
    //   this.popupOptions.visible = true;
    //   this.popupOptions.closeCallback = this.closeWorkMeasurePopup;
    // },
    // closeWorkMeasurePopup(data) {
    //   this.popupOptions.target = null;
    //   this.popupOptions.visible = false;
    //   if (data && data.length > 0) {
    //     this.$set(this.process, 'workMeasurementPlanId', data[0].workMeasurementPlanId)
    //     this.$set(this.process, 'measPlanContent', data[0].measPlanContent)
    //   }
    // },
    // removeWorkMeasure() {
    //   this.$set(this.process, 'workMeasurementPlanId', null)
    //   this.$set(this.process, 'measPlanContent', null)
    // },
    saveProcess() {
      this.$refs['editForm'].validate().then(_result => {
        if (_result) {
          window.getApp.$emit('CONFIRM', {
            title: '확인',
            message: '저장하시겠습니까?',
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.process.chgUserId = this.$store.getters.user.userId

              this.isSave = !this.isSave
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    saveProcessCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.$emit('saveProcess', this.process.processCd)
    },
  }
};
</script>
